export interface Testimonial {
  id: number;
  name: string;
  location: string;
  role?: string;
  text: string;
  rating: number;
  type: 'alta-costura' | 'arreglos';
  date: string;
  service: string;
}

export const allTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'María Elena Castellanos',
    location: 'Madrid, España',
    text: 'Anthony no solo diseñó mi vestido de gala, creó una pieza de arte que capturó mi esencia. La atención en su atelier de Barcelona fue de una exclusividad que nunca había experimentado. Cada detalle, desde el bordado hasta el ajuste final, refleja una dedicación artesanal inigualable.',
    rating: 5,
    type: 'alta-costura',
    date: '2026-03-15',
    service: 'Vestido de Gala Noches de Gala',
  },
  {
    id: 2,
    name: 'Isabella Rossi',
    location: 'Milán, Italia',
    text: 'Viajé desde Milán específicamente para conocer el atelier de Anthony en Barcelona. Su visión del lujo artesanal es única en Europa. Mi vestido para la Fashion Week fue un éxito absoluto. La combinación de técnica española y sensibilidad parisina crea algo verdaderamente especial.',
    rating: 5,
    type: 'alta-costura',
    date: '2025-11-22',
    service: 'Vestido Seda Pintada Jardín Secreto',
  },
  {
    id: 3,
    name: 'Victoria Hernández',
    location: 'Caracas, Venezuela',
    text: 'Le encargué mi vestido de novia desde Caracas y coordinamos todo online. Las pruebas virtuales y el envío de muestras de tela fueron impecables. El día de mi boda, el vestido ajustado a la perfección me hizo sentir la novia más hermosa del mundo. Anthony entiende que la emoción importa tanto como la técnica.',
    rating: 5,
    type: 'alta-costura',
    date: '2025-08-10',
    service: 'Vestido de Novia Eternidad',
  },
  {
    id: 4,
    name: 'Claire Dubois',
    location: 'París, Francia',
    text: 'Como alguien que conoce bien la alta costura francesa, debo decir que el trabajo de Anthony está a la altura de los grandes ateliers de la Place Vendôme. Su chaqueta bordada en brocado italiano es una de las piezas más exquisitas que poseo. El hilo de oro, la caída del tejido, el ajuste milimétrico: todo es impecable.',
    rating: 5,
    type: 'alta-costura',
    date: '2025-05-18',
    service: 'Chaqueta Bordada Oro Antiguo',
  },
  {
    id: 5,
    name: 'Sofía Martínez',
    location: 'Barcelona, España',
    text: 'Encargué un vestido para la inauguración de mi galería de arte. Anthony capturó exactamente la dualidad que quería: elegancia clásica con un toque contemporáneo. La seda pintada a mano es una conversación en sí misma. Mis invitados no dejaron de preguntarme dónde lo había conseguido.',
    rating: 5,
    type: 'alta-costura',
    date: '2026-01-30',
    service: 'Vestido de Gala Personalizado',
  },
  {
    id: 6,
    name: 'Laura Fernández',
    location: 'Barcelona, España',
    text: 'Llevé un abrigo de lana para ajustarlo y quedé impresionada con la rapidez y profesionalidad. En menos de una semana tenía una prenda que parecía hecha exclusivamente para mí. Los precios son justos y el trato es cercano. Recomiendo sus servicios de arreglo sin dudarlo.',
    rating: 5,
    type: 'arreglos',
    date: '2026-04-02',
    service: 'Entallar abrigo de lana',
  },
  {
    id: 7,
    name: 'Carmen Ruiz',
    location: 'Barcelona — Eixample',
    text: 'Llevé mi abrigo de lana para entallarlo y en tres días lo tenía perfecto. El trato fue cercano y profesional. El precio muy razonable para la calidad del trabajo. Volveré con toda mi ropa de invierno.',
    rating: 5,
    type: 'arreglos',
    date: '2026-03-20',
    service: 'Entallar abrigo',
  },
  {
    id: 8,
    name: 'Pablo Medina',
    location: 'Barcelona — Gràcia',
    text: 'Cambié la cremallera de mi chaqueta de cuero y quedó como nueva. Me sorprendió la rapidez y el detalle en el acabado. Incluso me aconsejaron sobre cómo cuidar la piel para que durara más. Volveré sin duda.',
    rating: 5,
    type: 'arreglos',
    date: '2026-02-14',
    service: 'Cambio de cremallera en cuero',
  },
  {
    id: 9,
    name: 'Ana López',
    location: 'Barcelona — Sant Gervasi',
    text: 'Transformaron un vestido antiguo de mi madre en algo moderno y elegante. El trabajo fue impecable y el resultado superó mis expectativas. Conseguir que una prenda con tanto valor sentimental tuviera nueva vida fue un regalo increíble.',
    rating: 5,
    type: 'arreglos',
    date: '2025-12-08',
    service: 'Transformación de vestido vintage',
  },
  {
    id: 10,
    name: 'Marta Jiménez',
    location: 'Barcelona — Sarrià',
    text: 'Llevé un pantalón de sastre que me quedaba mal de la cintura. No solo lo ajustaron perfectamente, sino que además me enseñaron cómo elegir mejor la talla la próxima vez. Ese nivel de atención no lo encuentras en ningún otro lado.',
    rating: 5,
    type: 'arreglos',
    date: '2026-04-18',
    service: 'Ajuste de pantalón de sastre',
  },
  {
    id: 11,
    name: 'Elena Vidal',
    location: 'Barcelona — El Born',
    text: 'Tenía una falda de seda con una rasgadura que pensaba que era irreparable. No solo la arreglaron, sino que el punto de reparación es prácticamente invisible. El trato fue amable, el precio justo y el resultado perfecto.',
    rating: 5,
    type: 'arreglos',
    date: '2026-01-10',
    service: 'Reparación de desgarrón en seda',
  },
  {
    id: 12,
    name: 'Beatriz Navarro',
    location: 'Valencia, España',
    text: 'Descubrí a Anthony a través de Instagram y decidí probar sus servicios de arreglo durante un viaje a Barcelona. Ahora organizo mis visitas a la ciudad pensando en llevarle ropa. Es mi sastre de confianza, aunque viva a 350 kilómetros.',
    rating: 5,
    type: 'arreglos',
    date: '2025-09-22',
    service: 'Ajustes varios (camisa + falda)',
  },
];

export const altaCosturaTestimonials = allTestimonials.filter(
  (t) => t.type === 'alta-costura'
);

export const arreglosTestimonials = allTestimonials.filter(
  (t) => t.type === 'arreglos'
);

export const stats = [
  { value: '5.0', label: 'Valoración media', suffix: '/5' },
  { value: '200+', label: 'Clientes satisfechos', suffix: '' },
  { value: '8', label: 'Países', suffix: '' },
  { value: '8', label: 'Años de trayectoria', suffix: '' },
];